// File: fade.js
// Import Highway
import Highway from '@dogstudio/highway';

// Fade
class Fade extends Highway.Transition {

    in({ from, to, done }) {
        document.documentElement.classList.remove('loading');

        // Reset Scroll
        window.scrollTo(0, 0);
        document.querySelector('.fullPage').scrollTo(0, 0);
        
        // Remove Old View
        from.remove();
        to.classList.add('view--active');
        setTimeout( ()=>{ 
            done();
        }, 260);
    }
        
    out({ from, done }) {
        document.documentElement.classList.add('loading');

        from.classList.remove('view--active');
        
        setTimeout( () => { 
            done(); 
        }, 260);
    }
}

export default Fade;